import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export function AuthenticationNotice() {
  const { login } = useAuth();

  return (
    <div className="w-full relative bg-gradient-to-br from-swapper-primary/5 to-[#9F7FFF]/5 border-2 border-swapper-primary/20 rounded-2xl p-6 md:p-8 shadow-lg">
      <div className="flex flex-col items-center gap-4 md:gap-6">
        {/* Icon */}
        <div className="relative bg-gradient-to-br from-swapper-primary to-[#9F7FFF] p-5 rounded-2xl shadow-md">
          <Mail className="w-8 h-8 md:w-10 md:h-10 text-white" />
        </div>

        {/* Text content */}
        <div className="text-center space-y-2 md:space-y-3 max-w-sm">
          <h3 className="text-lg md:text-xl font-bold text-swapper-secondary">
            Sign in to continue
          </h3>
          <p className="text-sm md:text-base text-swapper-secondary/70 leading-relaxed px-2">
            Sign in with your email to complete tasks and earn rewards.
          </p>
        </div>

        <Button
          onClick={() => login()}
          className="w-full max-w-sm bg-gradient-to-br from-swapper-primary to-[#9F7FFF] hover:opacity-90 text-white font-semibold rounded-xl px-6 py-3 transition-all duration-200 ease-out hover:shadow-glow text-sm md:text-base"
        >
          <span className="inline-flex items-center justify-center gap-2">
            <Mail className="w-5 h-5" />
            <span>Sign in</span>
          </span>
        </Button>
      </div>
    </div>
  );
}
